import React from 'react';
import { Menu, Button, Avatar, Group, Text } from '@mantine/core';
import { IconLogout } from '@tabler/icons-react';
import { useAuth0 } from '@/hooks/useAuth0';

export const UserMenu = React.memo(function UserMenu() {
  const { user, logout } = useAuth0();

  if (!user) return null;

  const initials = user.name
    ? user.name.split(' ').map((n: string) => n[0]).join('').toUpperCase()
    : user.email?.charAt(0).toUpperCase() || '?';

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button 
          variant="subtle" 
          px="sm" 
          py={0}
          h="auto"
          style={{ maxWidth: '300px', overflow: 'visible' }}
        >
          <Group gap="xs" wrap="nowrap" align="center" py={6}>
            <Avatar size={28} radius="xl" color="blue">
              {initials}
            </Avatar>
            <Text size="sm" fw={500} truncate style={{ maxWidth: '200px' }}>
              {user.email}
            </Text>
          </Group>
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          color="red"
          leftSection={<IconLogout size={14} />}
          onClick={() => logout()}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
});